import {Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Favorite, FavoriteList} from '@models/favorite';
import {AdService} from '@services/ad.service';
import {MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
@Component({
    selector: 'app-add-compare',
    templateUrl: './add-compare.component.html',
    styleUrls: ['./add-compare.component.scss']
})
export class AddCompareComponent implements OnInit {
    favoriteForm = new UntypedFormGroup({
        listFavorite: new UntypedFormControl(''),
        favorite: new UntypedFormControl(''),
    });
    listFavorites: FavoriteList[] = [];
    favorites: Favorite[] = [];

    constructor(
        private adService: AdService,
        public dialogRef: MatDialogRef<AddCompareComponent>,
        public trackingService: TrackingService) {
    }

    ngOnInit(): void {
        this.adService.getFavoritesLists().subscribe(result => {
            this.listFavorites = result;
        });
    }

    loadFavorites() {
        if (this.favoriteForm.get('listFavorite').value) {
            this.adService.getFavoritesList(this.favoriteForm.get('listFavorite').value).subscribe(result => {
                this.favorites = result.favorites;
            });
        } else {
            this.favorites = [];
        }
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favoriteForm.valid && this.favoriteForm.get('favorite').value) {
            this.adService.addCompareAd(this.favoriteForm.get('favorite').value);
            this.dialogRef.close(true);
        }
    }
}
